/**
 * Vom Daumen zur Laufrichtung (Produktentscheidung vom 23.10.2026).
 *
 * ALLES ODER NICHTS. Wie weit der Daumen ausgelenkt ist, entscheidet nur
 * ueber die RICHTUNG - niemals ueber das Tempo. Jede Eingabe ausserhalb der
 * Totzone laeuft mit vollem Tempo.
 *
 * Robin aus dem Spiel: "Wenn ich den Joystick nicht ganz ausfahre, sieht die
 * Bewegungsanimation aus, als liefe die Person in Zeitlupe. Die Eingabe soll
 * immer eine Alles-oder-nichts-Eingabe sein, damit Animation und
 * Bewegungsgeschwindigkeit immer uebereinstimmen. Am PC ist es ja genauso:
 * WASD nutzt immer das maximale Tempo."
 *
 * Bis dahin war die Auslenkung ein Gaspedal: halb ausgefahren hiess halbes
 * Tempo. Das Laufbild kennt aber nur EINE Geschwindigkeit - es lief also
 * immer zu schnell zum tatsaechlichen Weg. Ein Gaspedal haette die Animation
 * mitziehen muessen; die Entscheidung fiel bewusst andersherum, weil die
 * Tastatur dasselbe Problem gar nicht erst hat.
 *
 * Die Regel steht hier und nicht in der Oberflaeche: So laesst sie sich ohne
 * Browser pruefen - und an EINER Stelle nachjustieren.
 */

/**
 * Kleiner toter Bereich um den Mittelpunkt, in Bildschirmpunkten.
 *
 * Darin gilt der Daumen als ruhend. Ohne ihn zittert jede aufgelegte Hand
 * den Hero hin und her - und seit alles oder nichts gilt, waere jedes
 * Zittern ein voller Schritt.
 */
export const JOYSTICK_DEAD_ZONE = 6;

/**
 * Die gemeldete Laufrichtung zu einer Daumenauslenkung.
 *
 * @param dx Auslenkung nach rechts, in Bildschirmpunkten.
 * @param dy Auslenkung nach unten, in Bildschirmpunkten.
 * @returns Richtung der LAENGE 1 - oder (0,0), wenn nichts gemeldet wird.
 */
export function joystickRichtung(dx: number, dy: number): { x: number; y: number } {
  if (!Number.isFinite(dx) || !Number.isFinite(dy)) return { x: 0, y: 0 };

  const laenge = Math.hypot(dx, dy);
  if (laenge < JOYSTICK_DEAD_ZONE) return { x: 0, y: 0 };

  return { x: dx / laenge, y: dy / laenge };
}
